import { render, staticRenderFns } from "./SurveyModalPopUp.container.vue?vue&type=template&id=b2510314&scoped=true&"
import script from "./SurveyModalPopUp.container.vue?vue&type=script&lang=ts&"
export * from "./SurveyModalPopUp.container.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyModalPopUp.container.vue?vue&type=style&index=0&id=b2510314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2510314",
  null
  
)

export default component.exports